import { getSnowplowEventPayload, logAnalyticsEvent } from 'Services/analytics/analytics';
import { ANALYTICS_CATEGORIES, SNOWPLOW_EVENTS } from 'Services/analytics/analytics.const';

const { AI_COMPANION } = ANALYTICS_CATEGORIES;
const { CLICK } = SNOWPLOW_EVENTS;

export const triggerAiCompanionVehicleLinkClickedEvent = (href: string): void => {
	const enquiryId = /\/vehicles\/(\d+)/.exec(href)?.[1] || '';

	const eventPayload = getSnowplowEventPayload({
		category: AI_COMPANION,
		customData: { label: enquiryId, url: href },
		name: 'dlr_ai_companion_vehicle_link_clicked',
		schemaName: CLICK.SCHEMA,
		version: CLICK.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};
